export var EmbeddedDataMediaType;
(function (EmbeddedDataMediaType) {
    EmbeddedDataMediaType["VIDEO"] = "video";
    EmbeddedDataMediaType["GIF"] = "gif";
})(EmbeddedDataMediaType || (EmbeddedDataMediaType = {}));
export var EmbeddedDataMediaPlayOptionsRepeat;
(function (EmbeddedDataMediaPlayOptionsRepeat) {
    EmbeddedDataMediaPlayOptionsRepeat["NONE"] = "none";
    EmbeddedDataMediaPlayOptionsRepeat["LOOP"] = "loop";
})(EmbeddedDataMediaPlayOptionsRepeat || (EmbeddedDataMediaPlayOptionsRepeat = {}));
//# sourceMappingURL=EmbeddedData.type.js.map